import { FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { FormattedMessage } from 'dibs-react-intl';

import { SeoLink, PARTIALLY_LINKABLE_LINK } from 'dibs-elements/exports/SeoLink';

import { PdpSharedShipsFrom_item$key } from './__generated__/PdpSharedShipsFrom_item.graphql';

import styles from './PdpSharedShipsFrom.scss';

const itemFragment = graphql`
    fragment PdpSharedShipsFrom_item on Item {
        locationBrowseUrl {
            path
            ...SeoLink_linkData
        }
        address {
            itemAddress: displayCityStateCountry(fullCountryName: true)
        }
    }
`;

export const PdpSharedShipsFrom: FC<{
    item?: PdpSharedShipsFrom_item$key | null;
}> = ({ item: itemRef }) => {
    const item = useFragment(itemFragment, itemRef || null);

    if (!item) {
        return null;
    }

    const itemLocation = item.address?.itemAddress;

    return (
        <div className={styles.shipsFromContainer}>
            <FormattedMessage
                id="PdpSharedShipsFrom.shipsFromLocation"
                defaultMessage="<label>Ships From:</label> {location}"
                values={{
                    label: content => <span className={styles.shipsFrom}>{content}</span>,
                    location: item.locationBrowseUrl?.path ? (
                        <SeoLink
                            linkData={item.locationBrowseUrl}
                            variant={PARTIALLY_LINKABLE_LINK}
                        >
                            {itemLocation}
                        </SeoLink>
                    ) : (
                        <span>{itemLocation}</span>
                    ),
                }}
            />
        </div>
    );
};
